import { getQuickViewDataById } from '../api/quick-view';
import {
  getUnitType,
  isMobile,
  googleMapStyles,
  defaultSwiperOptions,
  getViewComparisonLink
} from '../modules/utilities';
import { closeModalGlobal, openModalGlobal, clearContent } from './modal';
import { handleSaveEvent } from './save-community';
import { handleAddToCompare } from '../api/compare';
import { openCompareWidget } from './compare-community';
import { addToastMessage } from './toast';
import { initDNI } from '../api/dni';

const maxCompare = 5;

let newPropertyContainer;
let fullScreenSwiperEl;
let fullScreenSwiper;
let counterEl;
let pinsize = screen.width > 767 ? 50 : 30;

export const initQuickViewModal = (id = '', dniId = '') => {
  clearContent();
  getQuickViewDataById(id)
    .then(quickViewData => {
      newPropertyContainer = document.createElement('div');
      newPropertyContainer.classList.add('property-container');
      let availableApartments = '';
      if (quickViewData.quickView && Array.isArray(quickViewData.quickView.AvailableApartments)) {
        quickViewData.quickView.AvailableApartments.forEach(aprt => {
          availableApartments += `<span>${getUnitType(aprt)}</span>`;
        })
      }
      let amenities = '';
      if (quickViewData.quickView && Array.isArray(quickViewData.quickView.Amenities)) {
        quickViewData.quickView.Amenities.forEach(amenity => {
          amenities += `
            <li>
              <i class="amenities-icon ${amenity.Icon}" aria-hidden="true"></i>
              <span>${amenity.Name}</span>
            </li>
          `;
        });
      }

      let imageFilters = '';
      let allImages = [];
      let imagesArray = [];
      if (quickViewData.quickView && quickViewData.quickView.Images) {
        imagesArray = Object.entries(quickViewData.quickView.Images);
        for (const [imgKey, images] of imagesArray) {
          allImages.push(...images);
          if(imgKey && imgKey != ""){
            imageFilters +=
              `<button class="filter" data-category="${imgKey}">
                <span>${imgKey} (${images.length})</span>
                <img src="${images[0]}" alt="${imgKey}">
              </button>`;
          }
        }
        imageFilters =
          `<button class="filter active" data-category="All">
            <span>All (${allImages.length})</span>
            <img src="${allImages[0]}" alt="all">
          </button>` + imageFilters;
      }

      let imageSliders = '';
      allImages.forEach((img, i) => {
        imageSliders += `
          <div class="swiper-slide">
            <img src="${img}" data-index="${i}" />
          </div>
        `;
      })

      newPropertyContainer.innerHTML = `
        <div class="image-gallery-buttons">
          <svg class="arrow-back"><use xlink:href="#arrow-back"></use></svg>
          <div class="image-gallery-view-btn">
            <svg class="grid-view"><use xlink:href="#grid-view"></use></svg>
            <svg class="list-view"><use xlink:href="#list-view"></use></svg>
          </div>
        </div>
        <div class="property-details">
          ${quickViewData.quickView && quickViewData.quickView.Name ? `<h1>${quickViewData.quickView.Name}</h1>` : ''}
          ${quickViewData.quickView && quickViewData.quickView.Address ? `<p class="address">${quickViewData.quickView.Address}</p>` : ''}
          ${availableApartments ? `
            <p class="property-types">
              ${availableApartments}
            </p>
          ` : ''}
          ${quickViewData.quickView && quickViewData.quickView.Description ? `
            <p class="description">${quickViewData.quickView.Description}</p>
          ` : ''}
          ${amenities ? `
            <ul class="amenities">
              ${amenities}
            </ul>
          ` : ''}

          ${quickViewData.quickView && quickViewData.quickView.PageUrl && quickViewData.labels && quickViewData.labels.ViewCommunity ? `
            <a href="${quickViewData.quickView.PageUrl}" class="view-community">
              ${quickViewData.labels.ViewCommunity}
            </a>
          ` : ''}
          ${quickViewData.quickView && quickViewData.quickView.PhoneNumber ? `
            <p class="call">
              <svg><use xlink:href="#phone"></use></svg>
              <a href="tel:${quickViewData.quickView.PhoneNumber}" class="DCRPhoneHref">
                ${quickViewData.labels.CallUs}: <span class="DCRPhone">${quickViewData.quickView.PhoneNumber}</span>
              </a>
            </p>
          ` : ''}

          <div class="actions">
            <a class="action-item apt-fav save${!isMobile ? ' rounded': ''}${quickViewData.quickView.IsSaved ? ' saved': ''}" href="#save" data-id="${id}">
              <svg class="saved-items"><use xlink:href="#saved-items"></use></svg>
              ${quickViewData.labels && quickViewData.labels.Favorite ? `
              <span>${quickViewData.labels.Favorite}</span>
            `: ''}

            </a>
            ${!quickViewData.quickView.ScheduleTourUrl.includes('scheduleatour') ? `
              <a class="action-item schedule${!isMobile ? ' rounded' : ''}" href="${quickViewData.quickView.ScheduleTourUrl}">
                <svg class="schedule-item"><use xlink:href="#calendar"></use></svg>
                ${quickViewData.labels && quickViewData.labels.ScheduleATour ? `
                <span>${quickViewData.labels.ScheduleATour}</span>
              `: ''}
              </a>
              `: ''}
            
            <a class="action-item compare${!isMobile ? ' rounded': ''}${quickViewData.quickView.IsCompare ? ' compared': ''}" data-id="${id}" href="#compare">
              <svg class="plus-item"><use xlink:href="#plus-thin"></use></svg>
              ${quickViewData.labels && quickViewData.labels.Compare ? `
            <span>${quickViewData.labels.Compare}</span>
            ` : ''}
            </a>
            ${isMobile ? `
              <a class="action-item mobile-call" href="tel:${quickViewData.quickView.PhoneNumber}" class="DCRPhoneHref">
                <svg><use xlink:href="#phone"></use></svg>
                <span>
                  ${quickViewData.labels.CallUs}
                </span>
              </a>
            ` : ''}
          </div>
        </div>
        <div class="media-container${imagesArray.length === 0 && !isMobile ? ' expanded-map' : ''}">
          ${imagesArray.length !== 0 ?
            `
            <div class="image-wrapper">
              <div class="filters">
                ${imageFilters}
              </div>
              <div class="swiper swiper-custom">
                <div class="swiper-wrapper">
                  ${imageSliders}
                </div>
                <div class="swiper-pagination swiper-pagination-custom"></div>
                ${!isMobile ? `
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                ` : ''}

              </div>
              <div class="image-gallery">
              </div>
            </div>
            ` : ''
          }
          <div class="map-wrapper">
            <div class="expand-map">
              <div id="expand-collapse-map">
                ${imagesArray.length !== 0 || isMobile ? `
                  <span id="expand-map">${quickViewData.labels.ExpandMap}</span>
                  <span id="collapse-map">${quickViewData.labels.CollapseMap}</span>
                  <svg><use xlink:href="#arrow-left"></use></svg>
                ` : ''}
              </div>
            </p>

          </div>
          <div id="quick-view-map">

          </div>
        </div>
        </div>
      `;
      newPropertyContainer.querySelector('.apt-fav.save').addEventListener('click', (e) => {
        handleSaveEvent(e);
      });
      const swiper = newPropertyContainer.querySelector('.swiper');
      if (swiper) {
        swiper.addEventListener('click', attachImageGalleryClick);
      }
      newPropertyContainer.querySelector('.action-item.compare').addEventListener('click', (e) => {
        e.stopPropagation();
        addToCompareHandler(e, allImages[0], quickViewData.quickView && quickViewData.quickView.Name);
      });
      newPropertyContainer.querySelector('#expand-collapse-map').addEventListener('click', (e) => {
        e.stopPropagation();
        newPropertyContainer.querySelector('.media-container').classList.toggle('expanded-map');
      });
      newPropertyContainer.querySelector('.arrow-back').addEventListener('click', arrowBackHandler);
      newPropertyContainer.querySelector('.image-gallery-view-btn').addEventListener('click', (e) => {
        e.stopPropagation();
        newPropertyContainer.querySelector('.image-gallery').classList.toggle('grid-view');
        newPropertyContainer.querySelector('.image-gallery-view-btn').classList.toggle('grid-view');
      });
      const imageGalleryContainerEl = newPropertyContainer.querySelector('.image-gallery');
      allImages.forEach((img, i) => {
        const imgEl = document.createElement('img');
        imgEl.setAttribute('src', img);
        imgEl.setAttribute('data-index', i);
        imageGalleryContainerEl.appendChild(imgEl);
        imgEl.addEventListener('click', imageGalleryElClick);

      })
      openModalGlobal(newPropertyContainer);
      initQuickViewMap(newPropertyContainer, quickViewData);
      imageSlider(newPropertyContainer, quickViewData);
      if(!isNaN(dniId)) initDNI(dniId);
    })
    .catch(console.error);
}

const attachImageGalleryClick = (e) => {
  e.stopPropagation();
  if (newPropertyContainer && isMobile) {
    const target = e.currentTarget;
    newPropertyContainer.classList.add('image-gallery-opened');
    const activeSlide = target.querySelector('.swiper-slide-active');
    const index = activeSlide.dataset.swiperSlideIndex;
    const imageGallery = newPropertyContainer.querySelector('.image-gallery');
    if (index && index !== '0' && imageGallery) {
      const imageToScroll = imageGallery.querySelector(`[data-index="${index}"]`);
      if (imageToScroll) {
        imageToScroll.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
}

const arrowBackHandler = (e) => {
  e.stopPropagation();
  if (newPropertyContainer.classList.contains('image-gallery-full-screen')) {
    newPropertyContainer.classList.remove('image-gallery-full-screen');
    fullScreenSwiperEl.remove();
    counterEl.remove();
    if (fullScreenSwiper) {
      fullScreenSwiper.destroy();
    }
  } else {
    newPropertyContainer.classList.remove('image-gallery-opened');
    newPropertyContainer.querySelector('.image-gallery-view-btn').classList.remove('grid-view');
    newPropertyContainer.querySelector('.image-gallery').classList.remove('grid-view');
  }
}

export const addToCompareHandler = (e, imgSrc, propertyName, position = 'middle') => {
  e.preventDefault();
  const isCompared = e.currentTarget.classList.contains('compared');
  const compareCount = document.querySelector('.compare-communities__list .community-list').getAttribute('data-count');
  handleAddToCompare(e)
    .then(() => {
      if (!isCompared && compareCount < maxCompare) {
        const props = {
          imgSrc: imgSrc,
          body: `${propertyName} added to your Compare list`,
          position,
        }
        const comparisonPageUrl = getViewComparisonLink();
        if (comparisonPageUrl) {
          props.btnText = 'View';
          props.btnHref = comparisonPageUrl;
        }
        addToastMessage(props);
      } else if (!isCompared && compareCount >= maxCompare) {
        addToastMessage({
          imgSrc: imgSrc,
          body: `You can only compare ${maxCompare} properties`,
          position,
        });
      } else {
        addToastMessage({
          imgSrc: imgSrc,
          body: `${propertyName} removed from your Compare list`,
          position,
        });
      }
    });
}

export const imageGalleryElClick = (e) => {
  e.stopPropagation();
  if (newPropertyContainer) {
    const target = e.currentTarget;
    const targetIndex = target.getAttribute('data-index');
    newPropertyContainer.classList.add('image-gallery-full-screen');
    fullScreenSwiperEl = document.createElement('div');
    fullScreenSwiperEl.classList.add('full-screen-swiper');

    counterEl = document.createElement('span');
    counterEl.classList.add('swiper-full-screen-counter')
    const images = [...newPropertyContainer.querySelector('.image-gallery').children];
    counterEl.innerHTML = `${+targetIndex + 1} / ${images.length}`;
    newPropertyContainer.appendChild(counterEl);
    newPropertyContainer.appendChild(fullScreenSwiperEl);
    let imageSliders = '';
    images.forEach(img => {
      const imgSrc = img.getAttribute('src');
      const dataIndex  = img.getAttribute('data-index');
      imageSliders += `
        <div class="swiper-slide">
          <img src="${imgSrc}" data-index="${dataIndex}" />
        </div>
      `;
    });
    fullScreenSwiperEl.innerHTML = `
      <div class="swiper-wrapper">
        ${imageSliders}
      </div>
    `;
    const swiperOptions = {
      loop: true,
      spaceBetween: 10,
      initialSlide: +targetIndex,
      on: {
        slideChange: (e) => {
          counterEl.innerHTML = `${e.realIndex + 1} / ${images.length}`;
        }
      }
    };
    fullScreenSwiper = new Swiper('.full-screen-swiper', swiperOptions);
  }
}

const initQuickViewMap = async (el, data) => {
  const { Map } = await google.maps.importLibrary("maps");
  const lat = data && data.quickView && data.quickView.Coordinates && data.quickView.Coordinates.Lat || 40.6839597;
  const lng = data && data.quickView && data.quickView.Coordinates && data.quickView.Coordinates.Lon || -74.2163569;
  const mapOptions = {
    center: { lat, lng },
    zoom: 15,
    disableDefaultUI: true,
    zoomControl: true,
    styles: googleMapStyles,
  };
  const map = new Map(el.querySelector("#quick-view-map"), mapOptions);
  const marker = new google.maps.Marker({
    position: { lat, lng },
    map: map,
    icon: {
      url: 'data:image/svg+xml;base64,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',
      scaledSize: new google.maps.Size(pinsize, pinsize)
    },
  });
}

const imageSlider = (el, data) => {
  const swiperOptions = Object.assign({}, defaultSwiperOptions);
  swiperOptions.navigation = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
  let swiper = new Swiper('.swiper', swiperOptions);

  const filters = el.querySelectorAll(".filter");
  const swiperWrapper = el.querySelector(".swiper-wrapper");

  filters.forEach((filter) => {
    filter.addEventListener("click", function (e) {
      const { category } = e.currentTarget.dataset;
      filters.forEach((otherFilter) => {
        if (otherFilter !== filter) {
          otherFilter.classList.remove("active");
        } else {
          otherFilter.classList.add("active");
        }
      });
      const slides = newPropertyContainer.querySelectorAll(".swiper-slide");
      const imageGallery = newPropertyContainer.querySelector('.image-gallery');
      slides.forEach(slide => slide.remove());
      if (imageGallery && imageGallery.children) {
        [...imageGallery.children].forEach((img) => img.remove());
      }
      let imagesToRender = [];
      if (category !== 'All') {
        imagesToRender = data.quickView.Images[category];
      } else if (category === 'All') {
        Object.values(data.quickView.Images).forEach(val => {
          imagesToRender.push(...val);
        })
      }
      imagesToRender.forEach((image, i) => {
        const imgEl = document.createElement('div');
        imgEl.classList.add('swiper-slide');
        const imgSrcEl = document.createElement('img');
        imgSrcEl.setAttribute('src', image);
        imgSrcEl.setAttribute('data-index', i);
        imgEl.appendChild(imgSrcEl);
        swiperWrapper.appendChild(imgEl);
        const imgGalleryEl = imgSrcEl.cloneNode(true);
        imgGalleryEl.addEventListener('click', imageGalleryElClick);
        imageGallery.appendChild(imgGalleryEl);
      })
      swiper.destroy();
      swiper = new Swiper('.swiper', swiperOptions);
    });
  });
};



// WEBPACK FOOTER //
// ./src/js/components/quick-view.js